import React, { ReactNode } from 'react'

import { Badge } from 'antd'

interface BadgeProps {
  count?: number
  status?: 'success' | 'error' | 'warning' | 'default' | 'processing'
  text?: string
  children?: ReactNode
  className?: string
}

const Display = (props: BadgeProps) => {
  return (
    <Badge {...props} count={props.status ? null : props.count ? props.count : 0}>
      {props.children}
    </Badge>
  )
}

export default Display
